// ═══════════════════════════════════════════════════════════════
// RollCall — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconLayoutDashboard, IconCalendarEvent, IconUsers,
  IconLogin, IconChartBar, IconFileText,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/rollcall', icon: IconLayoutDashboard, exact: true },
  { label: 'Events', path: '/rollcall/events', icon: IconCalendarEvent },
  { label: 'Personnel', path: '/rollcall/personnel', icon: IconUsers },
  { label: 'Check-In', path: '/rollcall/checkin', icon: IconLogin },
  { label: 'Analytics', path: '/rollcall/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Reports', path: '/rollcall/reports', icon: IconFileText, minLevel: 'editor' },
];

export default function RollCallLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('rollcall', NAV_ITEMS);

  const isDetail = pathname.match(/\/rollcall\/event\/\d/) ||
    pathname.match(/\/rollcall\/personnel\/\d/) ||
    pathname.endsWith('/badges') ||
    pathname.endsWith('/import');

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'RollCall', to: '/rollcall' },
            ...(currentPage && currentPage.path !== '/rollcall' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {visibleItems.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
